import { AVAILABILITY_MANAGEMENT_ACTIONS } from '../actions/availabilityActions';

// ─── HELPERS ──────────────────────────────────────────────────────────────────
const isSameData = (prev, next) =>
	JSON.stringify(prev) === JSON.stringify(next);

const toArray = (val) => (Array.isArray(val) ? val : []);

// ─── INITIAL STATE ─────────────────────────────────────────────────────────────
const initialState = {
	loading: {
		tables:         false,
		updateRevised:  false,
	},
	availabilityTable:  [],
	blendedTable:       [],
	pairedCitiesTable:  [],
	error: null,
};

// ─── REDUCER ──────────────────────────────────────────────────────────────────
const AvailabilityManagementReducer = (state = initialState, action) => {
	switch (action.type) {

		// ── Get Availability Management Tables ────────────────────────────────
		case AVAILABILITY_MANAGEMENT_ACTIONS.AM_GET_TABLES_REQUEST:
			return { ...state, loading: { ...state.loading, tables: true }, error: null };
		case AVAILABILITY_MANAGEMENT_ACTIONS.AM_GET_TABLES_SUCCESS: {
			const availabilityTable = toArray(action.payload?.availabilityTable);
			const blendedTable      = toArray(action.payload?.blendedTable);
			const pairedCitiesTable = toArray(action.payload?.pairedCitiesTable);

			// avoid re-renders when the poll returns identical data
			if (isSameData(state.availabilityTable, availabilityTable)
				&& isSameData(state.blendedTable, blendedTable)
				&& isSameData(state.pairedCitiesTable, pairedCitiesTable))
				return { ...state, loading: { ...state.loading, tables: false } };

			return {
				...state,
				loading: { ...state.loading, tables: false },
				availabilityTable,
				blendedTable,
				pairedCitiesTable,
				error: null,
			};
		}
		case AVAILABILITY_MANAGEMENT_ACTIONS.AM_GET_TABLES_FAILURE:
			return { ...state, loading: { ...state.loading, tables: false }, error: action.error };

		// ── Update Availability Revised ───────────────────────────────────────
		case AVAILABILITY_MANAGEMENT_ACTIONS.AM_UPDATE_REVISED_REQUEST:
			return { ...state, loading: { ...state.loading, updateRevised: true }, error: null };
		case AVAILABILITY_MANAGEMENT_ACTIONS.AM_UPDATE_REVISED_SUCCESS:
			return { ...state, loading: { ...state.loading, updateRevised: false } };
		case AVAILABILITY_MANAGEMENT_ACTIONS.AM_UPDATE_REVISED_FAILURE:
			return { ...state, loading: { ...state.loading, updateRevised: false }, error: action.error };

		default:
			return state;
	}
};

export default AvailabilityManagementReducer;
